"use strict";

var _objectWithoutProperties = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");
var _objectSpread = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stateModelFactory = exports.configSchema = void 0;
var mobx_state_tree_1 = require("mobx-state-tree");
var mobx_1 = require("mobx");
var clone_1 = __importDefault(require("clone"));
var configuration_1 = require("../configuration");
var util_1 = require("../util");
var mst_1 = require("../util/types/mst");
var configSchema = (0, configuration_1.ConfigurationSchema)('BaseFeatureWidget', {});
exports.configSchema = configSchema;
function formatSubfeatures(obj, depth, parse) {
  var currentDepth = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var returnObj = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var _a;
  if (depth <= currentDepth) {
    return returnObj;
  }
  returnObj.subfeatures = (_a = obj.subfeatures) === null || _a === void 0 ? void 0 : _a.map(function (sub) {
    formatSubfeatures(sub, depth, parse, currentDepth + 1, returnObj);
    return parse(sub);
  });
  return returnObj;
}
function stateModelFactory(pluginManager) {
  return mobx_state_tree_1.types.model('BaseFeatureWidget', {
    id: mst_1.ElementId,
    type: mobx_state_tree_1.types.literal('BaseFeatureWidget'),
    featureData: mobx_state_tree_1.types.frozen(),
    formattedFields: mobx_state_tree_1.types.frozen(),
    unformattedFeatureData: mobx_state_tree_1.types.frozen(),
    view: mobx_state_tree_1.types.safeReference(pluginManager.pluggableMstType('view', 'stateModel')),
    track: mobx_state_tree_1.types.safeReference(pluginManager.pluggableMstType('track', 'stateModel')),
    trackId: mobx_state_tree_1.types.maybe(mobx_state_tree_1.types.string),
    trackType: mobx_state_tree_1.types.maybe(mobx_state_tree_1.types.string)
  }).actions(function (self) {
    return {
      setFeatureData: function setFeatureData(featureData) {
        self.unformattedFeatureData = featureData;
      },
      clearFeatureData: function clearFeatureData() {
        self.featureData = undefined;
      },
      setFormattedData: function setFormattedData(feat) {
        self.featureData = feat;
      },
      setExtra: function setExtra(type, trackId) {
        self.trackId = trackId;
        self.trackType = type;
      }
    };
  }).actions(function (self) {
    return {
      afterCreate: function afterCreate() {
        (0, mobx_state_tree_1.addDisposer)(self, (0, mobx_1.autorun)(function () {
          var _a, _b;
          self.setExtra((_a = self.track) === null || _a === void 0 ? void 0 : _a.type, (_b = self.track) === null || _b === void 0 ? void 0 : _b.configuration.trackId);
          var unformattedFeatureData = self.unformattedFeatureData,
            track = self.track;
          var session = (0, util_1.getSession)(self);
          if (unformattedFeatureData) {
            var feature = (0, clone_1.default)(unformattedFeatureData);
            var f = function f(obj, arg2) {
              return (0, configuration_1.getConf)(obj, ['formatDetails', arg2], {
                feature: feature
              });
            };
            if (track) {
              // eslint-disable-next-line no-underscore-dangle
              feature.__jbrowsefmt = _objectSpread({}, f(session, 'feature'), f(track, 'feature'));
              var depth = (0, configuration_1.getConf)(track, ['formatDetails', 'depth']);
              formatSubfeatures(feature, depth, function (sub) {
                // eslint-disable-next-line no-underscore-dangle
                sub.__jbrowsefmt = _objectSpread({}, f(session, 'subfeature'), f(track, 'subfeature'));
              });
            }
            self.setFormattedData(feature);
          }
        }));
      }
    };
  }).preProcessSnapshot(function (snap) {
    // @ts-ignore
    var featureData = snap.featureData,
      finalizedFeatureData = snap.finalizedFeatureData,
      rest = _objectWithoutProperties(snap, ["featureData", "finalizedFeatureData"]);
    return _objectSpread({
      unformattedFeatureData: featureData,
      featureData: finalizedFeatureData
    }, rest);
  }).postProcessSnapshot(function (snap) {
    // xref https://github.com/mobxjs/mobx-state-tree/issues/1524 for Omit
    var unformattedFeatureData = snap.unformattedFeatureData,
      featureData = snap.featureData,
      rest = _objectWithoutProperties(snap, ["unformattedFeatureData", "featureData"]); // finalizedFeatureData avoids running formatter twice if loading from
    // snapshot
    return _objectSpread({
      // replacing undefined with null helps with allowing fields to be
      // hidden, setting null is not allowed by jexl so we set it to
      // undefined to hide. see config guide. this replacement happens both
      // here and when displaying the featureData in base feature widget
      finalizedFeatureData: JSON.parse(JSON.stringify(featureData, function (_, v) {
        return typeof v === 'undefined' ? null : v;
      }))
    }, rest);
  });
}
exports.default = stateModelFactory;
exports.stateModelFactory = stateModelFactory;